<template>
    <div class="bussiness-login-comp">
        <reset-pwd></reset-pwd>
        <div class="input-block account">
            <label for="account" class="landing-input-label">
                電子郵件帳號
                <span v-show="error.bussiness.email" class="error-with-title">{{error.bussiness.email}}</span>
            </label>
            <div class="input-error-group">
                <input class="landing-input" :class="{error: error.bussiness.email}" type="text" v-model="bussiness.email" placeholder="請輸入電子郵件帳號">
            </div>
        </div>
        <div class="input-block  password">
            <label for="password" class="landing-input-label">
                密碼
                <span v-show="error.bussiness.password" class="error-with-title">{{error.bussiness.password}}</span>
            </label>
            <div class="input-error-group">
                <input class="landing-input" ref="password" :class="{error: error.bussiness.password}" type="password" v-model="bussiness.password" placeholder="請輸入密碼">
                <div v-if="bussiness.pwdShow" @click="togglePassword()" class="show-hide-pwd">
                    <span v-if="bussiness.pwdVisible">
                        隱藏
                    </span>
                    <span v-else>
                        顯示
                    </span>
                </div>
            </div>
        </div>
        <div class="sub-functions">
            <div class="remember-me">
                <!-- 記住我 -->
            </div>
            <div v-if="$route.name !== 'bizExperienceLogin'" class="forgot-password" @click="forgotPwd()">
                忘記密碼？
            </div>
        </div>
        <div class="landing-default-btn" @click="bussinessLogin()">登入</div>
    </div>
</template>

<script>
import resetPwd from '@/components/bussiness/widges/modals/resetPwd.vue';
import constant from '@/constant'
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            bussiness: {
                email: null,
                password: null,
                pwdVisible: false,
                pwdShow: false
            },
            error: {
                bussiness: {
                    email: null,
                    password: null,
                }
            },
        }
    },
    mounted () {
        console.log(this.$route.name)
    },
    watch: {
        'bussiness.email': function (val) {
            let isMail = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
            
            if( val.length > 0 ){
                if (!isMail.test(val)) {
                    this.error.bussiness.email = '電子郵件格式錯誤';
                }else {
                    this.error.bussiness.email = null;
                }
            }else{
                this.error.bussiness.email = null;
            }
        },
        'bussiness.password': function (val) {
            this.error.bussiness.email = null;
            if(val){
                this.bussiness.pwdShow = true
                this.error.bussiness.password = null
            }else{
                this.bussiness.pwdShow = false
            }
        },
    },
    methods: {
        bussinessLogin: function () {
            // if(this.mobileRedirect()){
                // let companyId = this.bussiness.companyId
            if(this.checkInput()){
                let email = this.bussiness.email
                let password = this.bussiness.password
                let data = {email, password}
                this.$store.dispatch('bizLogin',data)
                .then((res) => {
                    console.log(res)
                    // window.location = "/bussiness/housestatus/home"
                    // console.log(res.data.result);
                    if(this.isBizVerified == 'NOT_AUDITS'){
                        window.location = '/enterprise/bizVerified'
                        // this.$router.push({ name: 'bizVerified'})
                    }else{
                        if(this.system != 'pc'){
                            window.location = '/mb/enterprise/'
                        }else{
                            window.location = '/enterprise/personalHome/myHome/'
                        }
                    }
                })
                .catch(err => {
                    console.log(err)
                    if( err == 'accountErr' ){
                        this.error.bussiness.email = '帳號或密碼錯誤'
                    }else if( err == 'noAccount' ){
                        this.error.bussiness.email = '帳號不存在'
                    }else if( err == 'verifyErr' ){
                        this.error.bussiness.email = '尚未通過驗證'
                    }else{
                        let alarm = {
                            status: true,
                            title: err,
                            description: null,
                            type: 'error'
                        }
                        this.$store.dispatch('setAlarmStatus', alarm)
                    }
                })
            }
            
            // }
        },
        forgotPwd: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'resetPwd'})
        },
        togglePassword: function () {
            let password = this.$refs.password;
            if (password.type === "password") {
                this.bussiness.pwdVisible = true
                password.type = "text";
            } else {
                this.bussiness.pwdVisible = false
                password.type = "password";
            }
        },
        checkInput: function () {
            if(!this.bussiness.email){
                this.error.bussiness.email = '請填寫電子郵件帳號'
            }
            if(!this.bussiness.password){
                this.error.bussiness.password = '請填寫密碼'
            }

            if(
                this.bussiness.email &&
                this.bussiness.password &&
                this.error.bussiness.email === null &&
                this.error.bussiness.password === null 
            ){
                return true
            }else{
                return false
            }
        }
    },
    computed: {
        ...mapGetters({
            system: 'GET_DEVICE_SYSTEM',
            appUrl: 'GET_APP_URL',
            isBizVerified: 'GET_BIZ_COMPANY_IS_VERIFIED',
        })
    },
    components: {
        resetPwd
    }
}
</script>

<style lang="scss" scoped>
    .bussiness-login-comp{
        .account{
            margin-bottom: 30px;
        }
        .password{
            margin-bottom: 18px;
            .show-hide-pwd{
                position: absolute;
                font-size: 16px;
                top: 15px;
                right: 16px;
                cursor: pointer;
            }
        }
        .sub-functions{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 38px;
            font-size: 18px;
            .remember-me{
                color: #9a9a9a;
            }
            .forgot-password{
                color: #36b0ff;
                cursor: pointer;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/registerFlow/login/loginComp.vue